export default __webpack_public_path__ + "static/media/684.47544002.png";